<div class="quick-search-panel" [class.open]="isOpen" [class.dark-theme]="isDarkMode" [class.light-theme]="!isDarkMode">
  <!-- HEADER -->
  <div class="quick-search-header">
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="d-flex align-items-center flex-grow-1 overflow-hidden mr-2">
        <button class="btn btn-icon mr-2" (click)="onClose()" title="Close search">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        <div class="header-titles text-truncate">
          <h6 class="mb-0 panel-title">Search Messages</h6>
          @if (chatTitle) {
          <small class="panel-subtitle text-truncate d-block">{{ chatTitle }}</small>
          }
        </div>
      </div>

      <div class="header-actions d-flex align-items-center">
        <!-- Date Filter Toggle Button -->
        <button class="btn btn-icon date-toggle-btn" [class.active]="isDateFilterActive || showDateFilter"
          (click)="toggleDateFilter()" title="Filter by date">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
          </svg>
          @if (isDateFilterActive) {
          <span class="date-filter-dot"></span>
          }
        </button>
      </div>
    </div>
  </div>

  <!-- SEARCH INPUT CONTAINER -->
  <div class="quick-search-input-area p-3">
    <div class="search-input-wrapper">
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <input #searchInput type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange($event)"
        placeholder="Search in chat..." class="form-control quick-search-input" />
      @if (searchQuery) {
      <button class="btn btn-icon clear-btn" (click)="clearSearch()" title="Clear search">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      }
    </div>

    <!-- EXPANDABLE DATE FILTER DRAWER -->
    @if (showDateFilter) {
    <div class="date-filter-box mt-2 p-2">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <span class="date-filter-label">Filter by date</span>
        @if (isDateFilterActive) {
        <button class="btn btn-link btn-sm clear-date-link p-0" (click)="clearDateFilter()">Clear dates</button>
        }
      </div>
      <div class="d-flex align-items-center date-inputs-row">
        <div class="date-input-group flex-grow-1">
          <label class="small text-muted mb-0">From</label>
          <input type="date" [(ngModel)]="startDate" (change)="onDateChange()" class="form-control form-control-sm" />
        </div>
        <span class="mx-2 text-muted mt-3">→</span>
        <div class="date-input-group flex-grow-1">
          <label class="small text-muted mb-0">To</label>
          <input type="date" [(ngModel)]="endDate" (change)="onDateChange()" class="form-control form-control-sm" />
        </div>
      </div>
    </div>
    }
  </div>

  <!-- RESULTS SUMMARY & STEPPER BAR -->
  @if (hasSearched && searchResults.length > 0) {
  <div class="quick-search-summary px-3 py-2 d-flex align-items-center justify-content-between">
    <div class="summary-text">
      @if (totalCount > 0) {
      <span>
        <strong>{{ currentResultIndex >= 0 ? (currentResultIndex + 1) : 1 }}</strong> of
        <strong>{{ totalCount }}</strong> match{{ totalCount > 1 ? 'es' : '' }}
      </span>
      } @else {
      <span>{{ searchResults.length }} result{{ searchResults.length > 1 ? 's' : '' }}</span>
      }
    </div>
    <div class="stepper-controls d-flex align-items-center">
      <button class="btn btn-icon stepper-btn" (click)="navigateResult('prev')" title="Previous match"
        [disabled]="searchResults.length <= 1">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="18 15 12 9 6 15"></polyline>
        </svg>
      </button>
      <button class="btn btn-icon stepper-btn ml-1" (click)="navigateResult('next')" title="Next match"
        [disabled]="searchResults.length <= 1">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </button>
    </div>
  </div>
  }

  <!-- RESULTS CONTAINER -->
  <div #resultsContainer class="quick-search-body flex-grow-1" (scroll)="onScroll($event)">
    <!-- Loading spinner (initial search) -->
    @if (isLoading && page === 1) {
    <div class="loading-state text-center py-5">
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="sr-only">Searching...</span>
      </div>
      <p class="text-muted">Searching messages...</p>
    </div>
    }

    <!-- Empty state: not searched yet -->
    @if (!hasSearched && !isLoading) {
    <div class="empty-state text-center py-5 px-4">
      <div class="empty-icon-circle mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
          stroke="#7d96d7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
      </div>
      <h6 class="empty-state-title mb-1">Search messages</h6>
      <p class="empty-state-desc text-muted small">
        Search for messages within this conversation by text or filter by date.
      </p>
    </div>
    }

    <!-- Empty state: searched but no results -->
    @if (hasSearched && searchResults.length === 0 && !isLoading) {
    <div class="empty-state text-center py-5 px-4">
      <div class="empty-icon-circle mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
          stroke="#a0aec0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          <line x1="8" y1="11" x2="14" y2="11"></line>
        </svg>
      </div>
      <h6 class="empty-state-title mb-1">No messages found</h6>
      <p class="empty-state-desc text-muted small">
        No matches found for <strong *ngIf="searchQuery">"{{ searchQuery }}"</strong>
        <span *ngIf="isDateFilterActive"> in the selected date range</span>.
      </p>
    </div>
    }

    <!-- Search Results List -->
    @if (searchResults.length > 0) {
    <div class="quick-search-list pb-4">
      @for (msg of searchResults; track (msg.id || msg._id || $index); let idx = $index) {
      <div class="quick-search-item px-3 py-2" [class.selected]="selectedMessageId === msg.id || currentResultIndex === idx"
        (click)="selectMessage(msg, idx)">
        <div class="d-flex w-100">
          <!-- Avatar -->
          <div class="avatar-col mr-2">
            <img [src]="getSenderAvatar(msg)" class="user-avatar rounded-circle"
              (error)="handleProfileImageError($event)" alt="Avatar" />
          </div>

          <!-- Main Info Column -->
          <div class="content-col flex-grow-1 min-width-0">
            <!-- Row 1: Sender & Time -->
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="sender-name font-weight-bold text-truncate mr-2">
                {{ getSenderName(msg) }}
              </span>
              <span class="msg-time text-muted small white-space-nowrap">
                {{ msg.createdAt | date:'MMM d, y, h:mm a' }}
              </span>
            </div>

            <!-- Row 2: Message Preview & Media Tag -->
            <div class="preview-row d-flex align-items-start">
              @if (msg.mediaBadge) {
              <span class="badge media-badge mr-2">{{ msg.mediaBadge }}</span>
              }
              <div class="message-preview-text flex-grow-1">
                @if (msg.textPreview) {
                <span [innerHTML]="msg.textPreview | highlightText:searchQuery"></span>
                } @else if (msg.mediaBadge) {
                <span class="text-muted font-italic">{{ msg.mediaBadge }} attachment</span>
                } @else {
                <span class="text-muted font-italic">Message</span>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      }

      <!-- Pagination loader -->
      @if (isLoading && page > 1) {
      <div class="pagination-loader text-center py-3">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="sr-only">Loading more...</span>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
